import * as React from "react";
import {useNavigate} from "react-router-dom";
import {useAuthDispatcher} from "../../context/AuthContext";
import {actionTypes} from "../../context/reducer";
import {removeUserRefreshToken} from "../../service/localStorage/LocalStorageService";
import {RouteInfo} from "../../route/RouteHelper";
import logOut from "../../assets/images/header/log-out-vector.svg"
import ButtonPrimaryRaiko from "../../raikoComponents/raikoButtons/ButtonPrimaryRaiko";
import ButtonSecondaryRaiko from "../../raikoComponents/raikoButtons/ButtonSecondaryRaiko";
import {css} from "@emotion/css";
import {styled} from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import PropTypes from 'prop-types';
import RaikoDefaultDialogPage, {DialogSize} from "../defaultDialogPage/RaikoDefaultDialogPage";

const LogOut = ({openDialog, handleClickClose}) => {
    const BootstrapDialog = styled(Dialog)(({theme}) => ({
        '& .MuiDialogContent-root': {
            padding: theme.spacing(2),
        },
        '& .MuiDialogActions-root': {
            padding: theme.spacing(1),
        },
    }));
    const BootstrapDialogTitle = (props) => {
        const {children, onClose, ...other} = props;

        return (
            <DialogTitle sx={{m: 0, p: 2}} {...other}>
                {children}
                {onClose ? (
                    <IconButton
                        aria-label="close"
                        onClick={onClose}
                        sx={{
                            position: 'absolute',
                            right: 8,
                            top: 8,
                            color: (theme) => theme.palette.grey[500],
                        }}
                    >
                        <CloseIcon/>
                    </IconButton>
                ) : null}
            </DialogTitle>
        );
    };

    BootstrapDialogTitle.propTypes = {
        children: PropTypes.node,
        onClose: PropTypes.func.isRequired,
    };

    const navigate = useNavigate()
    const dispatcher = useAuthDispatcher()

    return (
        <>
            <RaikoDefaultDialogPage
                onClose={handleClickClose}
                open={openDialog}
                dialogSize={DialogSize.WRAP_CONTENT}
            >
                <section className="dialogContent">
                    <img src={logOut} alt="logOut" width={200} height={200}/>

                    <span className={
                        css`color: var(--color-text);
                          font-size: var(--text-size-medium);
                          margin-top: 1rem;
                        `}>
                            خروج از حساب کاربری
                        </span>

                    <span
                        className={css`color: var(--color-text);
                          margin-top: .5rem;`}>آیا می خواهید از حساب کاربری خود خارج شوید؟</span>
                    <div className={css`
                      width: 100%;
                      padding: 1rem;
                      display: flex;
                      gap: 0.5rem`}>
                        <ButtonPrimaryRaiko
                            className="w-100"
                            label="انصراف"
                            onClick={handleClickClose}
                        />

                        <ButtonSecondaryRaiko
                            className="w-100"
                            label="خروج"
                            autoFocus
                            onClick={_ => doUserLoginOut(dispatcher, navigate)}
                        />

                    </div>

                </section>

            </RaikoDefaultDialogPage>
        </>
    )
}
export default LogOut

export function doUserLoginOut(dispatcher, navigate) {

    dispatcher({
        type: actionTypes.LOGOUT,
        token: null
    })

    removeUserRefreshToken()
    navigate(RouteInfo.Login.globalUrl)
}